/* v8 ignore start */

import get from "lodash/get";
import find from "lodash/find";
import {
  actionIconIds,
  aspectOfLifeNameToFontAwesomeIcon,
} from "../../pcs-constants";

function getActionIconIDTextFromActionID(actionId) {
  const lookup = find(actionIconIds, { ActionIconID: actionId });
  if (lookup === undefined) {
    return "";
  }
  return `${lookup.FullTitle} (${lookup.AspectOfLifeName})`;
}

function getFontAwesomeIconFromActivity(activity) {
  const actionId = get(activity, "externalSourceMeta.ActionIconID", null);
  if (actionId == null) {
    return "";
  }
  const lookup = find(actionIconIds, { ActionIconID: actionId });
  if (lookup === undefined) {
    return "";
  }
  return aspectOfLifeNameToFontAwesomeIcon[lookup.AspectOfLifeName];
}

function getActionIconIDText(activity) {
  const actionId = get(activity, "externalSourceMeta.ActionIconID", null);
  if (actionId == null) {
    return "";
  }
  return getActionIconIDTextFromActionID(actionId);
}

function getActionIconIDTextAsClass(activity) {
  const actionId = get(activity, "externalSourceMeta.ActionIconID", null);
  if (actionId == null) {
    return "";
  }
  const lookup = find(actionIconIds, { ActionIconID: actionId });
  if (lookup === undefined) {
    return "";
  }
  const kebabCase = (string) =>
    string
      .replace(/([a-z])([A-Z])/g, "$1-$2")
      .replace(/[\s_]+/g, "-")
      .toLowerCase();
  return `actioniconid-${actionId} ${kebabCase(lookup.FullTitle)} ${kebabCase(
    lookup.AspectOfLifeName,
  )}`;
}

export {
  getActionIconIDText,
  getActionIconIDTextFromActionID,
  getFontAwesomeIconFromActivity,
  getActionIconIDTextAsClass,
};
/* v8 ignore stop */
